import { request, requestXlsxFileDownload } from '../utils/axios-utils';
import { useMutation, useQuery } from 'react-query';

export const fetchSkuAndModalList = orderId => {
    return request({ url: `assignment/getSkusForDD/${orderId}`, method: 'GET' });
};

export const fetchModalList = data => {
    const [_blank, pageNum, pageSize] = data.queryKey;
    return request({
        url: `models/listing?pageNum=${pageNum || 1}&pageSize=${pageSize || 10}`,
        method: 'GET',
    });
};

export const fetchModal = modelId => {
    return request({ url: `models/${modelId}`, method: 'GET' });
};

const AddOccasion = data => {
    return request({
        url: `models/addOccasion`,
        method: 'PATCH',
        data,
    });
};

const removeOccasion = data => {
    return request({
        url: `models/removeOccasion`,
        method: 'PATCH',
        data,
    });
};

const assignToClient = data => {
    return request({
        url: `models/assignToClient`,
        method: 'PATCH',
        data,
    });
};

const makePublic = data => {
    return request({
        url: `models/makePublic`,
        method: 'PATCH',
        data,
    });
};

const removeFromClient = data => {
    return request({
        url: `models/removeFromClient`,
        method: 'PATCH',
        data,
    });
};

export const useRemoveFromClient = (onSuccess, onError) => {
    return useMutation(removeFromClient, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const useMakePublic = (onSuccess, onError) => {
    return useMutation(makePublic, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const useAssignToClient = (onSuccess, onError) => {
    return useMutation(assignToClient, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const useRemoveOccasion = (onSuccess, onError) => {
    return useMutation(removeOccasion, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const useAddOccasion = (onSuccess, onError) => {
    return useMutation(AddOccasion, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const fetchBaseFacePresignedUrl = (file, modelName, occasionName) => {
    return request({
        url: `models/getPresignedUrl`,
        method: 'GET',
        params: {
            modelName,
            occasionName,
            filename: file.name,
            mimeType: file.type,
        },
    });
};

export const useFetchModels = (onSuccess, select) => {
    return useQuery('modelList', fetchModalList, {
        onSuccess: onSuccess ? onSuccess : null,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
        select: select ? data => select(data.data) : data => data.data,
    });
};

export const useFetchModelById = modelId => {
    return useQuery(`getModel_${modelId}`, () => fetchModal(modelId), {
        select: data => data.data,
    });
};

const listModelsForAssignment = companyId =>
    request({
        url: 'models/listForAssignment',
        method: 'GET',
        params: { companyId },
    });

export const useListModelsForAssignment = companyId =>
    useQuery(['modelsForAssignment', companyId], () => listModelsForAssignment(companyId), {
        enabled: !!companyId,
        select: data => data.data,
        refetchOnWindowFocus: false,
    });

export const downloadSku = id => {
    return requestXlsxFileDownload({
        url: `order/${id}/downloadSkuData`,
        method: 'GET',
    });
};

export const downloadOutboundReport = id => {
    return requestXlsxFileDownload({
        url: `order/outbound/report`,
        method: 'post',
        data: { orderId: id },
    });
};

export const useDownloadOutboundReport = (onSuccess, onError) => {
    return useMutation(downloadOutboundReport, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

const ignoreForCC = orderId => {
    
    return request({
        url: `order/markAllSkusForCC `,
        method: 'PUT',
        data: {
            orderId,
        },
    });
};

export const useIgnoreforCC = (onSuccess, onError) => {
    return useMutation(ignoreForCC, {
        onSuccess: onSuccess,
        Error: onError,
    });
};
